import styled, { css, keyframes } from 'styled-components'

import { spacing } from '@global/theme'
import { THEME_NAME } from '@global/constants'

const getSize = size => {
  const s = (() => {
    switch (size) {
      case 'xsmall': return spacing.oneAndAHalf
      case 'small': return spacing.two
      case 'large': return spacing.three
      case 'xlarge': return spacing.four
      case 'xxlarge': return spacing.six
      case 'hmedium': return spacing.eight
      case 'big': return spacing.ten
      default: return spacing.twoAndAHalf
    }
  })()

  return css`
    width: ${s};
    height: ${s};
    font-size: ${s};
  `
}

const getBorderSize = size => {
  switch (size) {
    case 'xsmall': return '2px'
    case 'small': return '2px'
    case 'large': return '3px'
    case 'xlarge': return '4px'
    case 'xxlarge': return '4px'
    default: return '3px'
  }
}

const Circle = css`
  border-radius: 50%;
  box-shadow: ${({ size, color, theme }) => {
    const borderSize = getBorderSize(size)
    const sColor = theme.colors[color]?.main || theme.colors.grays.main
    return `0 0 0 ${borderSize} ${sColor}`
  }};
`
const Spin = keyframes`
  0% {
      transform: rotate(0deg);
  }
  
  to {
      transform: rotate(3turn);
  }
`
const Rotation = css`
  animation: ${Spin} 2.5s reverse linear infinite;
`

export const StyledIcon = styled.span`
  ${({ size }) => getSize(size)};
  color: ${({ disabled, color, theme }) => {
    if (disabled) return theme.colors.text.disabled
    if (color) return theme.colors[color]?.main
    if (theme.name === THEME_NAME.DARK) return theme.colors.text.content
    return theme.colors.text.white
  }};
  ${({ circle }) => circle && Circle};
  ${({ spin }) => spin && Rotation};
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};
`
